/* unplugin-vue-components disabled */import script from "./YtbRootLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./YtbRootLayout.vue?vue&type=script&setup=true&lang=js"

import "./YtbRootLayout.vue?vue&type=style&index=0&id=2a14ea20&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a14ea20"]])

export default __exports__